import { render } from "./img-yay.vue?vue&type=template&id=02d7e3fe&lang=pug"
import script from "./img-yay.vue?vue&type=script&lang=js"
export * from "./img-yay.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__